module.exports = __webpack_public_path__ + "media/images/turbochargers/Garrett-cb941f6d05e96f0705b8df00fa506b89.jpg";